import styled from 'styled-components';
import { apx, fontFamilySize } from '../../../../../../../../contrib/ui';

export const SlotStyled = styled.div`
  flex-basis: 21%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .slot-label {
    color: #878787;
    ${fontFamilySize()}

    line-height: ${apx(18)};
  }
  .slot-value {
    color: var(--dark);
    ${fontFamilySize('Bold', 16)}
    line-height: ${apx(26)};
  }
  .slot-extra {
    margin-left: 0;
  }
`;
